import useApiRequest from 'api/useApiRequest';
import { fetchCrmEmailRecipientsExport, fetchCrmEmailPerformanceExport } from 'api/services/crmEmailExportService';

const useCrmEmailExport = () => {
  const { request } = useApiRequest();

  const exportRecipientsCsv = async ({ emailId, signal }) => {
    const { data } = await fetchCrmEmailRecipientsExport(request, { emailId, signal });
    return data;
  };

  const exportPerformanceCsv = async ({ emailId, signal }) => {
    const { data } = await fetchCrmEmailPerformanceExport(request, { emailId, signal });
    return data;
  };

  return { exportRecipientsCsv, exportPerformanceCsv };
};

export default useCrmEmailExport;
